<template>
    <div>
        <v-row>
            <v-col cols="12"
                   md="2"
                   lg="2"
            >
                <v-text-field v-model="searchText"
                              solo
                              flat
                              hide-details
                              dense
                              background-color="rgba(0,0,0,0.1)"
                              placeholder="Search questions"
                              clearable
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <h2 class="font-weight-medium mt-2">
                    {{ totalQuestions }} total questions
                </h2>
            </v-col>
            <v-col v-if="canShowComponent"
                   class="d-flex"
                   style="justify-content : flex-end"
            >
                <h3 v-if="!loadingExport"
                    class="font-weight-regular mr-2 mt-2 clickable-text"
                    @click="exportExcel"
                >
                    Download questions
                </h3>
                <h3 v-else
                    class="font-weight-regular mr-2 mt-2"
                >
                    Generating report
                </h3>
                <v-btn v-if="!loadingExport"
                       icon
                       class="mr-5"
                       @click="exportExcel"
                >
                    <v-icon large>
                        mdi-file-download-outline
                    </v-icon>
                </v-btn>
                <v-progress-circular
                    v-else
                    indeterminate
                    class="mr-5"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-pagination
                    v-if="pagination.total > 1"
                    v-model="currentPage"
                    :length="pagination.total"
                    circle
                    total-visible="6"
                    class="mb-4"
                    color="secondary"
                />
                <questions-list :loading="loading"
                                :items="items"
                />
                <v-row align="center"
                       align-content="center"
                       justify="center"
                >
                    <v-col class="d-flex"
                           cols="1"
                           sm="1"
                    >
                        <small class="d-flex justify-right"
                               style="width: 100%; white-space: nowrap"
                        >
                            Rows per page
                        </small>
                    </v-col>
                    <v-col class="d-flex"
                           cols="1 sm=1"
                    >
                        <v-select v-model="rowsPerPageSelected"
                                  :items="rowsPerPageItems"
                                  :label="undefined"
                                  outlined
                                  dense
                                  hide-details
                                  @input="rowsPerPageChanged"
                        >
                            <template v-slot:selection="{item}">
                                <span class="d-flex justify-end"
                                      style="width: 100%"
                                >{{ item }}</span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col
                        class="d-flex"
                        cols="6"
                        sm="3"
                    >
                        <v-pagination
                            v-if="pagination.total > 1"
                            v-model="currentPage"
                            :length="pagination.total"
                            circle
                            total-visible="6"
                            color="secondary"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import { debounce } from 'lodash';
    import {mapGetters, mapState} from 'vuex';
    import ProjectStatisticsService from '@/services/ProjectStatisticsService';
    import QuestionsList from '../Elements/QuestionsList';
    import {STATS_QUESTIONS_EXPORT_URL} from '../../../../services/ApiService';
    import {$http} from '../../../../services/http';

    export default {
        name: 'QuestionsStatistics',
        components: {QuestionsList},
        props:{
            selectedEvent: {
                type: Object,
                required: true
            },
        },
        data() {
            return {
                rowsPerPageSelected: 5,
                offset:0,
                pagination: {
                    current: 1,
                    total: 1,
                },
                loading: false,
                items: [],
                totalQuestions: 0,
                loadingExport: false,
                rowsPerPageItems: [5, 10, 15, 20, 25, 50, 100],
                searchText: '',
            };
        },
        watch: {
            searchText: debounce(function () {
                this.pagination.current = 1;
                this.loadData();
            },400),
        },
        computed: {
            ...mapGetters('projects', ['currentProjectId']),
            ...mapGetters('auth', ['canSeeRegistrationData']),
            ...mapState('projects', ['project']),
            currentEventId(){
                return this.selectedEvent._id;
            },
            currentPage: {
                get() {
                    return this.pagination.current;
                },
                set(value) {
                    this.pagination.current = value;
                    this.loadData();
                },
            },
            canShowComponent() {
                return this.canSeeRegistrationData(this.project);
            },
        },
        methods: {
            rowsPerPageChanged() {
                this.currentPage = 1;
                this.loadData();
            },
            loadData(){
                if (!this.currentProjectId) {
                    return;
                }
                this.loading = true;
                ProjectStatisticsService.getStatisticsQuestions(this.currentEventId, this.getParams())
                    .then((data)=>{
                        this.items = data.questions;
                        this.totalQuestions = data.pagination.itemCount;
                        this.pagination.total = Math.floor(data.pagination.pageCount);
                        this.loading = false;
                    });
            },
            getParams() {
                const params = {};
                if (this.searchText) {
                    params['search'] = this.searchText;
                }
                if (this.currentPage && this.currentPage > 1) {
                    params['page'] = this.currentPage;
                }
                params['perPage'] = this.rowsPerPageSelected;
                return params;
            },
            exportExcel() {
                this.loadingExport = true;
                const url = STATS_QUESTIONS_EXPORT_URL.replace('{event_id}', this.currentEventId);
                $http({
                    url,
                    method: 'GET',
                    responseType: 'blob'
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const hiddenElement = document.createElement('a');
                    hiddenElement.download = 'questions-' + this.currentEventId + '.xlsx';
                    hiddenElement.href = url;
                    hiddenElement.click();
                });
                this.loadingExport = false;
            }
        },
        mounted() {
            this.loadData();
        }
    };
</script>
<style scoped>
.clickable-text:hover{
    cursor: pointer;
}
</style>
